export const initialstate = {
  calendarEvents: [
    {
      title: 'Atlanta Monster',
      start: new Date('2022-04-04 00:00'),
      id: '1001',
    },
    {
      title: 'My Favorite Murder',
      start: new Date('2022-04-05 00:00'),
      id: '1002',
    },
  ],
  events: [
    { title: 'Meeting', id: '1', icon: 'fa fa-birthday-cake' },
    { title: 'Party', id: '2', icon: 'fa fa-user' },
    { title: 'Long Event', id: '3', icon: 'fa fa-plane' },
    { title: 'Lunch', id: '4', icon: 'fa fa-file-text' },
    { title: 'Happy Hour', id: '5', icon: 'fa fa-briefcase' },
  ],
};
